<nav>
  <div class="logo">
    <a routerLink="home" routerLinkActive="active">
      <img src="assets/logo.png" alt="Strona główna" routerLink="/" />
    </a>
  </div>

  <ul class="nav-menu" [@collapse]="mobileNav">
    <li>
      <a routerLink="about" routerLinkActive="active">{{
        "nav.about" | translate
      }}</a>
      <div class="nav-menu-addition">→</div>
    </li>
    <li>
      <a routerLink="offers" routerLinkActive="active">{{
        "nav.offer" | translate
      }}</a>
      <div class="nav-menu-addition">→</div>
    </li>

    <li>
      <a routerLink="references" routerLinkActive="active"
        >{{ "nav.ref" | translate }}
      </a>
      <div class="nav-menu-addition">→</div>
    </li>
    <li>
      <a routerLink="policy" routerLinkActive="active">{{
        "nav.policy" | translate
      }}</a>
      <div class="nav-menu-addition">→</div>
    </li>
    <li>
      <a routerLink="contact" routerLinkActive="active"
        >{{ "nav.contact" | translate }}
      </a>
      <div class="nav-menu-addition">→</div>
    </li>
  </ul>

  <div class="language-switch">
    <button
      (click)="lang1 = 'en'"
      [ngClass]="lang1 === 'en' ? 'lang active' : 'lang'"
      (click)="setLang('en')"
    >
      En
    </button>
    <button
      (click)="lang1 = 'pl'"
      [ngClass]="lang1 === 'pl' ? 'lang active' : 'lang'"
      (click)="setLang('pl')"
    >
      Pl
    </button>
    <button class="menu-toggle" (click)="toggleMenu()">☰</button>
  </div>
</nav>
